import styled from "styled-components";
import {
  glassCardStyles,
  Page,
  PrimaryButton,
  theme,
  typography,
} from "./views/Homepage/styles";

export const ErrorBoundaryPage = styled(Page)`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 32px 16px;
  overflow: hidden;
`;

export const ErrorBoundaryGlow = styled.div`
  pointer-events: none;
  position: absolute;
  inset: 0 0 auto;
  height: 420px;
  background-image: ${theme.gradientHero};
`;

export const ErrorBoundaryCard = styled.section`
  ${glassCardStyles};
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 28rem;
  padding: 32px 24px 28px;
  border-radius: 1rem;
  text-align: center;

  @media (min-width: 640px) {
    padding: 40px 36px 32px;
  }
`;

export const ErrorBoundaryBrand = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
  color: ${theme.foreground};
`;

export const ErrorBoundaryLogo = styled.img`
  width: auto;
  height: 36px;
  object-fit: contain;
`;

export const ErrorBoundaryBrandText = styled.span`
  font-size: 1.25rem;
  font-weight: ${typography.weights.bold};
  letter-spacing: -0.02em;
`;

export const ErrorBoundaryBrandAccent = styled.span`
  background-image: ${theme.gradientGold};
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
`;

export const ErrorBoundaryEyebrow = styled.p`
  margin: 0 0 8px;
  color: ${theme.primary};
  font-size: 0.75rem;
  font-weight: ${typography.weights.semibold};
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;

export const ErrorBoundaryTitle = styled.h1`
  margin: 0 0 12px;
  color: ${theme.foreground};
  font-size: 1.75rem;
  font-weight: ${typography.weights.bold};
  letter-spacing: ${typography.tracking.tight};
  line-height: 1.2;
`;

export const ErrorBoundaryCopy = styled.p`
  margin: 0 0 24px;
  color: ${theme.textMuted};
  font-size: 0.9375rem;
  line-height: 1.6;
`;

export const ErrorBoundaryAction = styled(PrimaryButton)`
  width: 100%;
  min-height: 48px;
`;

export const ErrorBoundaryHint = styled.p`
  margin: 16px 0 0;
  color: ${theme.textMuted};
  font-size: 0.8125rem;
  line-height: 1.5;
`;
